import { useLazyCallback } from "hooks/useLazyCallback";
import { FC, Suspense, useRef, useState } from "react";
import wrapperHOC from "@Utils/wrapperHOC";

interface ILazyLoadOnScroll {
  children: JSX.Element;
  fallback?: JSX.Element | string;
  customRootMargin?: string;
  callback?: any;
  noLazy?: boolean;
}

const LazyLoadOnScroll: FC<ILazyLoadOnScroll> = ({
  children,
  fallback,
  customRootMargin,
  callback = null,
  noLazy = false,
}) => {
  const [isIntersecting, setIsIntersecting] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);

  useLazyCallback(
    () => {
      setIsIntersecting(true);
      if (callback) callback();
    },
    { rootMargin: customRootMargin || "300px 0px 600px 0px" },
    ref,
    [],
    noLazy,
  );

  if (!isIntersecting) {
    return <div ref={ref}>{fallback}</div>;
  }

  return <Suspense fallback={fallback || <div>Loading...</div>}>{children}</Suspense>;
};

LazyLoadOnScroll.defaultProps = {
  fallback: "",
  customRootMargin: "",
};

export default wrapperHOC(LazyLoadOnScroll, {
  componentName: "LazyLoadOnScroll-Global",
  showForChina: true,
});
